export default __webpack_public_path__ + "static/media/img1pro9.809ffcdc.jpeg";